































































































































































































































































































































































































































































































































































































































import Modal from "@/components/shared/modal/Modal.vue";
import Vue from "vue";
import { Component, Prop, Watch, PropSync } from "vue-property-decorator";
import { Validations } from "vuelidate-property-decorators";
import { required } from "vuelidate/lib/validators";

@Component({
  components: {
    MbeModal: Modal
  }
})
export default class ModalCPMContent extends Vue {
  @Prop({})
  shipment: any;
  @Prop({})
  couriers: any[];
  @Prop({})
  courierSelected: any;
  @Prop({ default: false })
  disabled: boolean;
  @Prop({ default: false })
  showSender: boolean;
  @Prop({ default: false })
  mol: boolean;
  @Prop({})
  itemSelected: any;
  @Prop({})
  goEditable: any;
  selectedTime = "";
  @PropSync("pickupDataContent") pickupData: any;

  courierNexiveId: any = 0;
  courierGLSId: any = 0;
  courierTntId: any = 0;
  courierSDAId: any = 0;
  pickupPreferredRangeTime: any = [new Date(), new Date()];
  pickupAlternativeRangeTime: any = [new Date(), new Date()];
  preferredTimeNexive: any = "morning";

  @Validations()
  validations() {
    return {
      pickupData: {
        required,
        note: { required },
        time: { required },
        alternativeTime: { required },
        date: { required }
      }
    };
  }
}
